export const setQueryParam = (name, value) => {
  const existingParams = new URLSearchParams(window.location.search);
  existingParams.set(name, value);
  const newUrl = `${window.location.pathname}?${existingParams.toString()}`;
  window.history.replaceState(null, '', newUrl);
}

export const getQueryParam = (name) => {
  const existingParams = new URLSearchParams(window.location.search);
  const param = existingParams.get(name);
  if(param){
    return param;
  }
}

export const deleteQueryParam = (name) => {
  const existingParams = new URLSearchParams(window.location.search);
  existingParams.delete(name);
}

export const navigateToDetail = (id, window, redirectRoute) => {
  const existingParams = new URLSearchParams(window.location.search);

  if (
    window &&
    window.location &&
    window.location.href &&
    window.location.pathname !== redirectRoute
  ) {
    window.location.href = `${redirectRoute}${id}/` + '?' + existingParams.toString();
  }
}